import { Component, Input } from '@angular/core';

@Component({
  selector: 'ca-memo-category-graph',
  templateUrl: './memo-category-graph.html'
})
export class MemoCategoryGraph {
  typeLabels = [];
  typeData;

  public barOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    tooltips: { enabled: false },
    scales: {
      xAxes: [
        {
          stacked: false,
          ticks: {
            beginAtZero: true
          }
        }
      ],
      yAxes: [
        {
          gridLines: {
            display: false
          },
          stacked: false,
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };
  public barColors = [
    {
      backgroundColor: [
        'rgba(79,177,166,0.6)',
        'rgba(79,177,166,1.0)',
        'rgba(79,177,166,0.6)',
        'rgba(79,177,166,1.0)',
        'rgba(79,177,166,0.6)',
        'rgba(79,177,166,1.0)',
        'rgba(79,177,166,0.6)',
        'rgba(79,177,166,1.0)',
        'rgba(79,177,166,0.6)',
        'rgba(79,177,166,1.0)',
        'rgba(79,177,166,0.6)',
        'rgba(79,177,166,1.0)',
        'rgba(79,177,166,0.6)',
        'rgba(79,177,166,1.0)',
        'rgba(79,177,166,0.6)',
        'rgba(79,177,166,1.0)'
      ]
    }
  ];

  @Input()
  set data(categories: Array<{ id: string; name: string; icon: string; score: number }>) {
    this.typeLabels = categories.map(cat => cat.name);
    this.typeData = categories.map(cat => cat.score);
  }
}
